import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import type { WidgetConversationalSearchDynamicBanner } from './dynamic-banner';

const empty = void 0;

export const setIcon = (isActivated: boolean) => isActivated ? 'chevron-up' : 'chevron-down';
export const renderIntro = (invoked: boolean, isLongQuery: boolean, processing: boolean, labelProvider: labelProviderInterface) => {
    if (!invoked) return empty;
    if (processing) {
      return isLongQuery
        ? labelProvider('conversational.search.banner.dynamic.long.loading', 'Loading your summary...')
        : labelProvider('conversational.search.banner.dynamic.initial.loading', 'Analyzing your query...');
    }

    return empty;
};

export const setLongQueryTimeout = (context: WidgetConversationalSearchDynamicBanner) => {
    context.fetchTimeout = setTimeout(() => {
        context.isLongQuery = true;
    }, 5000);
};

/**
 * Delays rerender by 1 second in order to load chat before before loading view.
 * Preventing elements position changes.
*/
export const delayLoadingViewUpdate = (context: WidgetConversationalSearchDynamicBanner) => {
    context.loadingUpdateTimeout = setTimeout(() => context.isProcessing = true, 1000);
};